import * as React from 'react';
import ReactTags, { TagComponentProps } from 'react-tag-autocomplete';
import { Tag } from '../../../../models';
import { VideoTag } from '../../../Video/VideoTags/VideoTag';
import './style.css';

export interface TagSearchInputProps {
  available: Array<Tag>;
  selected: Array<Tag>;
  onAddSearchTag: (tag: Tag) => void;
  onRemoveSearchTag: (tag: Tag) => void;
}

export interface TagSearchInputState {
  /* empty*/
}

export class TagSearchInput extends React.Component<
  TagSearchInputProps,
  TagSearchInputState
> {
  render() {
    const {
      available,
      selected,
      onAddSearchTag,
      onRemoveSearchTag
    } = this.props;

    return (
      <ReactTags
        tags={selected}
        suggestions={available}
        handleDelete={index => onRemoveSearchTag(selected[index])}
        handleAddition={onAddSearchTag}
        tagComponent={this.renderTag}
      />
    );
  }

  private renderTag = (props: TagComponentProps): JSX.Element => {
    return (
      <VideoTag tag={props.tag as Tag} doNotLinkTag={true}>
        <button
          type="button"
          className="tag-search-close-button"
          onClick={props.onDelete}
        >
          X
        </button>
      </VideoTag>
    );
  };
}



// WEBPACK FOOTER //
// ./src/app/components/Search/SearchForm/TagSearchInput/index.tsx